import React from "react";
import "./loadingStyle.css";
import dot from "./dot.png";

const Loading = () => {
  return (
    <div className="loading-icon">
      <div className="loading-dots">
        <img src={dot} alt="loading dot" />
        <img src={dot} alt="loading dot" />
        <img src={dot} alt="loading dot" />
        <img src={dot} alt="loading dot" />
        <img src={dot} alt="loading dot" />
      </div>
    </div>
  );
};

export default Loading;
